import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { AlertFunctionType, setShow } from '../../../store/reducers/app/CustomAlertSlice'
import { Colors } from '../../../constants/Colors'
import style from './CustomAlert.module.css'
import CustomAlertButton from './CustomAlertButton'
import { domain } from '../../../api/main'

const sounds = ['notification.wav', 'notificationother.wav']

const CustomAlert = () => {

    const dispatch = useAppDispatch()

    const theme = useAppSelector<string>(state => state.theme.theme)

    const title = useAppSelector<string | null>(state => state.customAlert.title)
    const description = useAppSelector<string | null>(state => state.customAlert.description)
    const functions = useAppSelector<AlertFunctionType[] | []>(state => state.customAlert.functions)
    const sound = useAppSelector<number>(state => state.customAlert.sound)

    const show = useAppSelector<boolean>(state => state.customAlert.show)

    const onChangeShow = () => {
        dispatch(setShow(false))
    }


    return (
        <>
        {show && <div className={style.container}>
            <div
                className={style.alert}
                style={{
                    border: `1px solid ${Colors[theme ?? 'light'].borderLighter}`,
                    backgroundColor: Colors[theme ?? 'light'].thirdBackground
                }}
            >
                <div
                    className={style.titleContainer}
                    style={{
                        borderBottom: `1px solid ${Colors[theme ?? 'light'].borderLighter}`
                    }}
                >
                    <h1
                        className={style.title}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {title}
                    </h1>
                </div>
                <div
                    className={style.descriptionContainer}
                    style={{
                        borderBottom: `1px solid ${Colors[theme ?? 'light'].borderLighter}`
                    }}
                >
                    <span
                        className={style.description}
                        style={{
                            color: Colors[theme ?? 'light'].text
                        }}
                    >
                        {description}
                    </span>
                </div>
                <div
                    className={style.buttonsContainer}
                >
                    {functions.length > 0
                        ? functions.map(
                            (fn, index) => <CustomAlertButton
                                key={index}
                                title={fn.title}
                                onClick={fn.onClick}
                                disabled={fn.disabled}
                            />
                        )
                        : <CustomAlertButton
                            key={1}
                            title={'OK'}
                            onClick={onChangeShow}
                            disabled={false}
                        />
                    }
                </div>
                {sound > 0 ? <audio
                    className={style.soundPlayer}
                    autoPlay
                >
                    <source
                        src={domain + `/public/sounds/store/${sounds[sound - 1]}`}
                        type="audio/wav"
                    />
                </audio>  : null}
            </div>
        </div>}
        </>
    )
}

export default CustomAlert